// mui
import {
	Box,
	BoxProps,
	Grid,
	GridProps,
	InputLabel,
	Switch as MuiSwitch,
	SwitchProps as MuiSwitchProps,
	Typography,
	TypographyProps,
} from '@mui/material';

// ui
import { IconCircle, IconCircleProps } from '../../ui/IconCircle/IconCircle';

// props
export interface SwitchProps extends MuiSwitchProps {
	BoxProps?: BoxProps;
	description?: TypographyProps;
	GridProps?: GridProps;
	IconCircleProps?: IconCircleProps;
	label?: string;
}

export const Switch = ({
	BoxProps,
	description,
	disabled,
	GridProps,
	IconCircleProps,
	id,
	label,
	required,
	...props
}: SwitchProps) => {
	return (
		<Box
			sx={(theme) => {
				return {
					borderColor: theme.palette.divider,
					borderRadius: 2,
					borderStyle: 'solid',
					borderWidth: 1,
					padding: theme.spacing(1, 1, 1, 1.5),
					...(BoxProps?.sx as object),
				};
			}}>
			<Grid alignItems="center" container justifyContent="space-between" spacing={2} {...GridProps}>
				<Grid item>
					<Grid alignItems="center" container spacing={2}>
						{IconCircleProps && (
							<Grid item>
								<IconCircle {...IconCircleProps} />
							</Grid>
						)}
						<Grid item>
							<InputLabel disabled={disabled} htmlFor={id} required={required} sx={{ margin: 0 }}>
								{label}
							</InputLabel>
							{description && (
								<Typography color="brand.grey.500" variant="caption" {...description} />
							)}
						</Grid>
					</Grid>
				</Grid>
				<Grid item>
					<MuiSwitch disabled={disabled} id={id} required={required} {...props} />
				</Grid>
			</Grid>
		</Box>
	);
};
